import * as React from 'react';

import {FileAudioRegularIcon} from 'shells/icon/svg/file-audio-regular-icon';

import type {GetActivityForModal_activity as Activity} from 'nutshell-graphql-types';

import {EmptyTab} from '../empty-tab';

import {Audio} from './audio';
import {checkHasRecordings, getAudioLog} from './helpers';
import {Video} from './video';

type Props = {
    activity: Activity;
};

export function Recordings(props: Props) {
    const {activity} = props;
    const {externalMeeting} = activity;

    const audioLog = activity.shouldDisplayAudio ? getAudioLog(activity) : null;

    const hasRecordings = checkHasRecordings(activity);

    const subtitle = activity.summaryStates.recordingEmptyState;

    return (
        <>
            {!hasRecordings || !activity.canViewSummaryDetails ? (
                <EmptyTab
                    title='No recording available'
                    subtitle={subtitle}
                    icon={FileAudioRegularIcon}
                />
            ) : (
                <div className='flex flex-dir-col gap-16 pad-16 flex-wrap'>
                    {audioLog && <Audio activity={activity} audioLog={audioLog} />}
                    {externalMeeting && activity.shouldDisplayVideo && (
                        <Video externalMeeting={externalMeeting} />
                    )}
                </div>
            )}
        </>
    );
}
